import { createRouter, createWebHashHistory } from 'vue-router'
import StreamsViewer from '../views/StreamsViewer.vue'

const routes = [
  {
    path: '/',
    name: 'Streams',
    component: StreamsViewer
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
